import { z } from 'zod';
import i18n from '@/i18n';

export interface AdFormRef {
  reset: () => void;
}

const imagesArraySchema = z
  .object({
    id: z.string(),
    src: z.string(),
  })
  .array()
  .min(1, i18n.t('common.required_at_least_1_image'));

export const adFormSchema = z.object({
  gender: z.string().min(1, i18n.t('common.required_field')),
  price: z.string().min(1, i18n.t('common.required_field')),
  name: z.string().min(1, i18n.t('common.required_field')),
  email: z
    .string()
    .min(1, i18n.t('common.required_field'))
    .email(i18n.t('common.invalid_address_entered')),
  phone: z.string().min(1, i18n.t('common.required_field')),
  isNew: z.boolean(),
  isDelivery: z.boolean(),
  city: z.string().min(1, i18n.t('common.required_field')),
  title: z.string().min(1, i18n.t('common.required_field')),
  description: z.string(),
  images: imagesArraySchema,
  presetImages: imagesArraySchema,
});

export type AdFormFields = z.infer<typeof adFormSchema>;

export const editAdFormSchema = adFormSchema.pick({
  price: true,
  isDelivery: true,
  description: true,
  images: true,
});

export type EditAdFormFields = z.infer<typeof editAdFormSchema>;
